<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">

      <b-form @submit.prevent="submitForm">
        <b-card-header class="border-0 pl-0">
          <h3 class="mb-0">{{$t('nuevo_estado_pago')}}</h3>
        </b-card-header>
        <b-row class="card-ing">
          <b-col md="2">
            <b-form-group label-for="estado">
              <template v-slot:label>
                {{$t('nombre')}} <span class="text-danger">*</span>
              </template>
              <b-form-input id="estado" v-model="form.nombre" required
                :placeholder="$t('ingrese_estado')"></b-form-input>
            </b-form-group>     
          </b-col>
          <b-col md="2">
            <b-form-group label="fecha" label-for="fecha">
              <template v-slot:label>
                {{$t('fecha')}} <span class="text-danger">*</span>
              </template>
              <b-form-input id="fecha" type="date" v-model="form.fecha" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button variant="danger" class="ml-2" @click="$router.push('/pagos')">
          <i class="fas fa-arrow-left"></i> {{$t('cancelar')}}
        </b-button>
        <b-button type="submit" variant="primary">
          {{$t('guardar')}}
        </b-button>
      </b-form>
    </base-header>
  </div>
</template>
<script>
import pagoService from '@/api/pagoService';
export default {
  data() {
    return {
      form: {
        nombre: '',
        fecha: '',
      },
    };
  },
  methods: {
    async submitForm() {
      try {        
        const response = await pagoService.create(this.form);
        if (!response) throw new Error('Ocurrio un error al crear el ingreso, intente nuevamente.');
        Swal.fire({
          title: "Creado correctamente",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          background: '#f8f9fa',
          customClass: {
            title: 'swal-title',
            icon: 'swal-icon',
          },
        });   
        this.$router.push(`/pagos/details/${response.estadoPagoID}`);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message
        });
      }
    }
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}

.row.card-ing {
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
  padding: 30px 0px;
  margin-bottom: 20px;
}
</style>
